import { Uint8DivisionByZeroError } from "./errors.js";

/**
 * Compute modulo of two Uint8 values
 *
 * @see https://voltaire.tevm.sh/primitives/uint8 for Uint8 documentation
 * @since 0.0.0
 * @param {import('./Uint8Type.js').Uint8Type} a - Dividend
 * @param {import('./Uint8Type.js').Uint8Type} b - Divisor
 * @returns {import('./Uint8Type.js').Uint8Type} Remainder (a % b)
 * @throws {Uint8DivisionByZeroError} If divisor is zero
 * @example
 * ```javascript
 * import * as Uint8 from './primitives/Uint8/index.js';
 * const a = Uint8.from(100);
 * const b = Uint8.from(7);
 * const remainder = Uint8.modulo(a, b); // 2
 * ```
 */
export function modulo(a, b) {
	if (b === 0) {
		throw new Uint8DivisionByZeroError("Modulo by zero", { dividend: a });
	}
	return /** @type {import('./Uint8Type.js').Uint8Type} */ (a % b);
}
